import { MonthYear, sameMonthYear, stringToMonthYear } from '@common/neo.tax';
import { useState } from 'react';

import { Question, QuestionCode } from '@neo.tax/shared';

interface UseShortYearPeriodQuestionProps {
  questions: Question[];
}

export const useShortYearPeriodQuestion = ({
  questions,
}: UseShortYearPeriodQuestionProps): {
  shortYearStartMonthYear: MonthYear | undefined;
  setShortYearStartMonthYear: (monthYear: MonthYear) => void;
  shortYearEndMonthYear: MonthYear | undefined;
  setShortYearEndMonthYear: (monthYear: MonthYear) => void;
  isShortYearDirty: boolean;
} => {
  const questionMappingByCode = new Map<QuestionCode, Question>(
    questions.map((question) => [question.questionCode, question]),
  );

  const shortYearStartMonthYearString =
    questionMappingByCode.get(QuestionCode.ShortYearStartMonthYear)?.answerValue || '';
  const shortYearEndMonthYearString = questionMappingByCode.get(QuestionCode.ShortYearEndMonthYear)?.answerValue || '';

  const initialShortYearStartMonthYear =
    shortYearStartMonthYearString !== '' ? stringToMonthYear(shortYearStartMonthYearString) : undefined;

  const initialShortYearEndMonthYear =
    shortYearEndMonthYearString !== '' ? stringToMonthYear(shortYearEndMonthYearString) : undefined;

  // Temporary fix for MonthYear. This should be removed once the short year question is combined into one (NEO-5604)
  const [shortYearStartMonthYear, setShortYearStartMonthYear] = useState<MonthYear | undefined>(
    initialShortYearStartMonthYear,
  );
  const [shortYearEndMonthYear, setShortYearEndMonthYear] = useState<MonthYear | undefined>(
    initialShortYearEndMonthYear,
  );

  const isShortYearStartDirty =
    (!initialShortYearStartMonthYear && !!shortYearStartMonthYear) ||
    (!!initialShortYearStartMonthYear &&
      !!shortYearStartMonthYear &&
      !sameMonthYear(initialShortYearStartMonthYear, shortYearStartMonthYear));

  const isShortYearEndDirty =
    (!initialShortYearEndMonthYear && !!shortYearEndMonthYear) ||
    (!!initialShortYearEndMonthYear &&
      !!shortYearEndMonthYear &&
      !sameMonthYear(initialShortYearEndMonthYear, shortYearEndMonthYear));

  const isShortYearDirty = isShortYearStartDirty || isShortYearEndDirty;

  return {
    shortYearStartMonthYear,
    setShortYearStartMonthYear,
    shortYearEndMonthYear,
    setShortYearEndMonthYear,
    isShortYearDirty,
  };
};
